import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, installGlobalClickTracker } from '@/lib/analytics';

export function useAnalytics() {
  const location = useLocation();
  const installedRef = useRef(false);
  const lastPathRef = useRef<string>('');

  useEffect(() => {
    if (!installedRef.current) {
      installGlobalClickTracker();
      installedRef.current = true;
    }
  }, []);

  useEffect(() => {
    // Skip admin/internal/auth pages
    const p = location.pathname;
    if (
      p.startsWith('/portal') ||
      p.startsWith('/profile') ||
      p.startsWith('/login') ||
      p.startsWith('/reset-password') ||
      p.startsWith('/pending-approval')
    ) {
      return;
    }
    // Skip traffic originating from Lovable preview/editor hosts
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    if (/lovable\.(app|dev)$/i.test(host) || /lovableproject\.com$/i.test(host)) {
      return;
    }
    if (lastPathRef.current === p) return;
    lastPathRef.current = p;
    trackPageview(p);
  }, [location.pathname]);
}
